module.exports = __webpack_public_path__ + "assets/holiday.be8679c54bc2f63c23f36895bffbdb63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/holiday.jpg
// module id = 318
// module chunks = 0